<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-80 md-xsmall-size-100 mx-auto">

    <tiny-slider 
      ref="slider"
      :mouse-drag="false" 
      :loop="false" 
      :controls="false" 
      :nav="false"
      :touch="false"
      items="1"      
    >
        <div><plan-selection :active="activeIndex == 0" @on-selected="selectPlan"></plan-selection></div>
        <!--div><plan-confirmation ref="confirmation" :active="activeIndex == 9" :plan-count="planCount" @on-back="back" @on-confirm="confirmOrder"></plan-confirmation></div-->
        <div><plan-checkout ref="checkout" :active="activeIndex == 1" :plan-count="planCount" @on-back="back" @on-confirm="confirmOrder"></plan-checkout></div>
        <div><plan-activation ref="activation" :active="activeIndex == 2" @on-finish="activated"></plan-activation></div>
    </tiny-slider>    
    </div>    
  </div>
</template>
<script>

import VueTinySlider from 'vue-tiny-slider'

import PlanSelection from "./Plan/PlanSelection.vue";
// import PlanConfirmation from "./Plan/PlanConfirmation.vue";
import PlanCheckout from "./Plan/PlanCheckout.vue";
import PlanActivation from "./Plan/PlanActivation.vue";

export default {
  components: {
    'tiny-slider': VueTinySlider,
    PlanSelection,
    // PlanConfirmation,
    PlanCheckout,
    PlanActivation
  },

  data() {
    return {      
      loader: this.$store.state.loader,
      session: this.$store.state.session,
      plan: this.$store.state.plan,
      planCount: 0,

      slider: this.$refs['slider'],
      activeIndex: 0,
    };
  },

  mounted: function () {
    this.$nextTick(function () {
      if (this.session.affid > 0)
        this.$functions.checkAffiliate(this.session.affid);
      
      if (this.session.coupon != '')
        this.$functions.checkCoupon(this.session.coupon, 0, this.session.cycle);

      this.goTo(this.activeIndex);          
    })
  },

  methods:{
    goTo(page) {
      this.activeIndex = page;
      this.$refs.slider.goTo(page);
      console.log(this.$refs['slider']);
    },

    back(){
      this.$store.commit('plan', ['id', '']);
      this.$store.commit('plan', ['name', '']);
      this.$store.commit('plan', ['icon', '']);
      this.$store.commit('plan', ['desc', '']);
      this.$store.commit('plan', ['monthly', '']);
      this.$store.commit('plan', ['annually', '']);
      this.$store.commit('plan', ['emails', '']);
      this.$store.commit('plan', ['freeDays', '']);
      window.scrollTo( 0, 0 );
      this.goTo(0);
    },

    selectPlan(plan, count) {
      const desc = plan.description.replace('<br/>&nbsp;','');

      this.$store.commit('plan', ['id', plan.id]);
      this.$store.commit('plan', ['name', plan.name]);
      this.$store.commit('plan', ['icon', plan.icon]);
      this.$store.commit('plan', ['description', desc]);
      this.$store.commit('plan', ['monthly', plan.monthly]);
      this.$store.commit('plan', ['annually', plan.annually]);
      this.$store.commit('plan', ['emails', plan.emails]);
      this.$store.commit('plan', ['freeDays', plan.freeDays]);

      const params = {'id'              : this.$store.state.session.id,
                      'email'           : this.$store.state.client.email,
                      'planid'          : this.$store.state.plan.id,
                      'counter_planselection' : 1 };
      this.$functions.addTrack(params);

      this.planCount = count;

      this.$gtm.trackEvent({
        event: 'Plano Selecionado',
        category: "checkout",
        action: "click",
        label: plan.name,
        transaction_id: this.$store.state.session.id,
        value: this.$store.state.session.cycle == 'annually' ? plan.annually : plan.monthly,
        currency: 'BRL',
        noninteraction: false,
      });
      
      this.$refs['checkout'].changeCycle(this.$store.state.order.cycle);
      window.scrollTo( 0, 0 );
      this.goTo(1);
    },

    confirmOrder(){
      if (this.plan.id > 0){
        this.$debug('Plan => confirmOrder');
        this.$debug(this.$store.state.ecommerce);

        const params = {'id'              : this.$store.state.session.id,
                        'email'           : this.$store.state.client.email,
                        'planid'          : this.$store.state.plan.id,
                        'affid'           : this.$store.state.order.affid,
                        'coupon'          : this.$store.state.order.coupon,
                        'billingcycle'    : this.$store.state.order.cycle,
                        'ecommerceprice'  : this.$store.state.ecommerce.price,
                        'hostingprice'    : this.$store.state.order.hostingPrice,
                        'counter_planconfirm' : 1 };
        this.$functions.addTrack(params);

        this.goTo(2);
        this.$refs['activation'].start();
      }
    },

    activated(){
      this.$debug('Plan => activated');

      const params = {'id'              : this.$store.state.session.id,
                      'email'           : this.$store.state.client.email,
                      'orderid'         : this.$store.state.order.id,
                      'ordertotal'      : this.$store.state.order.total,
                      'hostingid'       : this.$store.state.hosting.id,
                      'ecommerceid'     : this.$store.state.ecommerce.id,
                      'totalfreedays'   : this.$store.state.order.totalDays,
                      'invoicedate'     : this.$store.state.order.nextDate,
                      'clientid'        : this.$store.state.client.id,
                      'counter_activation' : 1 };
      this.$functions.addTrack(params);

      dataLayer.push({
        orderId: this.$store.state.order.id,
        planId: this.$store.state.plan.id,
        planName: this.$store.state.plan.name,
        groupid: this.$store.state.session.gid,
        
        total: this.$store.state.order.total,
        cycle: this.$store.state.order.cycle,
        affid: this.$store.state.order.affid,
        coupon: this.$store.state.order.coupon,
      });

      this.$gtm.trackEvent({
        event: 'Concluído',
        category: "purchase",
        action: "activated",
        label: this.$store.state.plan.name,
        transaction_id: this.$store.state.session.id,        
        value: this.$store.state.order.total,        
        currency: 'BRL',
        noninteraction: false,
        user_data: { // Adiciona campos de Enhanced Conversions
          email: this.$store.state.client.email,      // Email do cliente
          phone_number: this.$store.state.client.phone // Telefone do cliente
        },
      });

      this.$functions.saveCookie('session', true);
      this.$functions.saveCookie('client', true);
      this.$functions.saveCookie('business', true);
      this.$functions.saveCookie('address', true);
      this.$functions.saveCookie('domain', true);
      this.$functions.saveCookie('plan', true);
      this.$functions.saveCookie('order', true);
      this.$functions.saveCookie('invoice', true);
      this.$functions.saveCookie('hosting', true);
      this.$functions.saveCookie('ecommerce', true);            

      this.$router.push({ path: 'concluido' });
    },

  },
}
</script>

<style lang="scss" scoped>

</style>